import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { memo } from "react";

/** Row that reports a value the merchant cannot change here. */
export const SettingsStaticRow = memo(function SettingsStaticRow({
  title,
  value,
}: {
  title: string;
  value: string;
}) {
  return (
    <Flex dir="column" gap="xxs" px="2xl" py="xl" w="full">
      <Text fontSize="xs" fontWeight="regular" textColor="tertiary">
        {title}
      </Text>
      <Text fontSize="sm" fontWeight="medium" textColor="primary">
        {value}
      </Text>
    </Flex>
  );
});
